import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { v4 as uuidv4 } from "uuid";
import * as _ from "lodash";
import {
  EditorState,
  convertToRaw,
  convertFromHTML,
  ContentState,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";

import {
  messageSuccess,
  messageError,
  valiDate,
  messageWarning,
  placeholderImage,
  url_path_images,
  addSlashes,
  customContentStateConverter,
  USER_KEY,
  onLoading,
  url_upload_images,
} from "../../helper";
import { UPDATE_SLIDE_IMAGE } from "./apollo";
import { Form, Modal, Spinner } from "react-bootstrap";
import compressImage from "../../helper/uploadFile";
import { Notify } from "notiflix";
import axios from "axios";
import { useMutation } from "@apollo/client/react";
export default function EditSlide({ item, onSuccess }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [image, setImage] = useState("");

  const [editorStateDescription, setEditorStateDescription] = useState(
    EditorState.createEmpty()
  );

  const description = draftToHtml(
    convertToRaw(editorStateDescription.getCurrentContent(item?.description))
  );

  const [updateSlide, { loading: adding }] = useMutation(UPDATE_SLIDE_IMAGE);

  useEffect(() => {
    if (item?.image) {
      setImage(item?.image);
    }
  }, [item]);

  useEffect(() => {
    if (item?.description) {
      const blocksFromHTML = convertFromHTML(item?.description);
      const editorStateDescription = EditorState.createWithContent(
        customContentStateConverter(
          ContentState.createFromBlockArray(
            blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap
          )
        )
      );
      setEditorStateDescription(editorStateDescription);
    }
  }, [item?.description]);

  const handleChangeFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      const compressedFile = await compressImage(file);
      const reader = new FileReader();
      reader.onload = async (e) => {
        setImage(e.target?.value);
        const formData = new FormData();
        formData.append("file", compressedFile);
        const res = await axios.post(url_upload_images, formData, {
          headers: {
            Authorization: localStorage.getItem(USER_KEY),
          },
        });
        const filename = res?.data?.filename;
        if (res.status === 200 && filename) {
          setImage(filename);
        } else {
          setImage("");
          Notify.messageError("ມີຂໍ້ຜິດພາດ");
        }
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      console.log(error);
      messageError("ອັບໂຫຼດບໍ່ສຳເລັດ");
    }
  };
  const { handleChange, errors, values, handleSubmit, resetForm, isDisabled } =
    useFormik({
      initialValues: {
        // description: item?.description,
        type: item?.type,
      },
      enableReinitialize: false,
      validate: (values) => {
        const errors = {};
        if (!values?.type) {
          errors.type = "ກະລຸນາເລືອກປະເພດ";
        }
        return errors;
      },
      onSubmit: async (values) => {
        try {
          const _arrayDescription = Array.from(description);
          const withEmojis = /\p{Emoji}/u;
          const _convertDescription = _arrayDescription?.map((char) => {
            if (withEmojis.test(char)) {
              return "&#x" + char.codePointAt(0).toString(16) + ";";
            } else {
              return char;
            }
          });
          const { data: updated } = await updateSlide({
            variables: {
              data: {
                description: addSlashes(_convertDescription.join("")),
                type: values?.type,
                image: String(image),
              },
              where: {
                id: parseInt(item?.id),
              },
            },
          });
          if (updated) {
            messageSuccess("ການດຳເນີນງານສຳເລັດ");
            setShow(false);
            onSuccess(true);
            resetForm();
          } else {
            messageError("ການດຳເນີນງານບໍ່ສຳເລັດ");
          }
        } catch (error) {
          messageError("ການດຳເນີນງານຜິດພາດ");
        }
      },
    });
  return (
    <React.Fragment>
      <button
        className="btn btn-icon  btn-success rounded-circle me-2"
        onClick={() => setShow(true)}
      >
        <i className="icon-edit-3" />
      </button>
      <Modal
        centered
        show={show}
        onHide={() => setShow(false)}
        animation={false}
        backdrop="static"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fs-5">
            <i className="icon-edit-3" /> ແກ້ໄຂຂໍ້ມູນໂຄສະນາ
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12 col-lg-12 col-md-12 col-sm-12">
              <div className="form-group">
                <div style={{ textAlign: "center" }}>
                  <input
                    type="file"
                    id="file-upload"
                    onChange={handleChangeFile}
                    accept="image/png, image/gif, image/jpeg"
                    hidden
                  />
                  <label for="file-upload">
                    <div
                      style={{
                        height: 250,
                        width: 500,
                        cursor: "pointer",
                        display: "flex",
                        backgroundImage: `url(${onLoading})`,
                        justifyContent: "center",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        textAlign: "center",
                        borderRadius: 7,
                      }}
                    >
                      {image ? (
                        <img
                          src={
                            image
                              ? url_path_images + image
                              : placeholderImage(500, 250)
                          }
                          alt={image}
                          style={{
                            height: 250,
                            width: 500,
                            borderRadius: 7,
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            backgroundImage: `url(${placeholderImage(
                              500,
                              250
                            )})`,
                            display: "flex",
                            height: 250,
                            width: 500,
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: 7,
                            backgroundSize: "cover",
                          }}
                        ></div>
                      )}
                    </div>
                  </label>
                </div>
              </div>
              <center>ອັບໂຫຼດຮູບພາບ</center>
            </div>
            <div className="col-12 col-lg-12 col-md-12 col-sm-12">
              <div className="form-group">
                <label>ປະເພດ{valiDate()}</label>
                <select
                  name="type"
                  className={
                    errors.type ? "form-control is-invalid" : "form-control"
                  }
                  onChange={handleChange}
                  value={values.type}
                >
                  <option value="">ເລືອກປະເພດ</option>
                  <option value="ACTIVITY">ກິດຈະກຳ (ACTIVITY)</option>
                  <option value="NEWS">NEWS ແຈ້ງການ (NEWS)</option>
                  <option value="COMMUNITY">ຊຸມຊົນ (COMMUNITY)</option>
                  <option value="PODCAST">PODCAST</option>
                  <option value="POST_APP">ໂຄສະນາຝັ່ງແອັບ</option>
                  <option value="POST_WEB">ໂຄສະນາຝັ່ງ ເວັບໄຊ</option>
                </select>
                <i className="text-danger">{errors.type}</i>
              </div>
              <div className="form-group">
                <label>ຫົວຂໍ້</label>
                <div
                  className="w-100"
                  style={{
                    minHeight: 300,
                    border: "1px solid #ccc",
                    borderRadius: 5,
                  }}
                >
                  <Editor
                    editorState={editorStateDescription}
                    rows={10}
                    toolbarClassName="toolbarClassName"
                    wrapperClassName="wrapperClassName"
                    editorClassName="px-3 custom-editor-content"
                    onEditorStateChange={setEditorStateDescription}
                    toolbar={
                      {
                        // image: { uploadCallback: handleUpload },
                      }
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary btn-lg hvr-shutter-out-horizontal"
            onClick={() => handleSubmit()}
            disabled={isDisabled}
          >
            <i className="icon-check-circle me-1" />
            ບັນທຶກ
          </button>
          <button
            type="button"
            className="btn btn-light btn-lg hvr-shutter-out-horizontal"
            onClick={() => handleClose()}
          >
            <i className="icon-x me-2" />
            ຍົກເລີກ
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
